import * as crmConstants from '../../constants/crm'
import { contactListConfSaveToLocalStorage } from '../../actions/crm'
 import { fetchSessionObj } from '../../actions/login'

// save to local storage every time filter, sorted get changed or resized columns
const contListSaveToLocalStorageOnUpdate = ({ dispatch }) => next => action => {
    next(action)
    if (action.type === crmConstants.CRM_CONTACT_LIST_FILTER_CHANGE ||
        action.type === crmConstants.CRM_CONTACT_LIST_SORT_CHANGE ||
        action.type === crmConstants.CRM_CONTACT_LIST_RESIZE_CHANGE) {
        dispatch(contactListConfSaveToLocalStorage())
    }
}

// fetch login session object
const fetchUserSessionObj = ({ dispatch }) => next => action => {
    next(action)
    if (action.type === crmConstants.CRM_FETCH_LEAD ||
        action.type === crmConstants.CRM_FETCH_LEADS) {
        dispatch(fetchSessionObj())
    }
}

export const crmMdl = [contListSaveToLocalStorageOnUpdate, fetchUserSessionObj]